export const FIRE_LOADING_MESSAGES = [
  'Crunching the numbers to see how soon you can stop pretending to enjoy Mondays.',
  'Asking a thousand simulated futures how many more status meetings you really need.',
  'Checking whether "retire early" can legally mean "before the next reorg."',
  'Calculating how much portfolio growth it takes to never open Slack at 8:59 AM again.',
  'Running the sacred math of "what if I simply did not want to work anymore?"',
  'Estimating the date your out-of-office message becomes a permanent lifestyle choice.',
  'Consulting the Monte Carlo crystal ball about your long-term relationship with payroll.',
  'Testing alternate timelines where your calendar has fewer recurring meetings and more weekdays off.',
  'Measuring the gap between your current finances and your dream of becoming aggressively unavailable.',
  'Simulating whether your investments can cover a lifetime of not saying "circling back."',
  'Calculating the exact price of never volunteering to take notes again.',
  'Projecting how soon your portfolio can replace your annual performance review.',
  'Running scenarios where your biggest workplace decision is whether to mute a group chat forever.',
  'Checking if compound growth can free you from small talk near the office coffee machine.',
  'Doing the long division on escaping alarm clocks, commutes, and fake enthusiasm.',
] as const;

export function shuffledFireLoadingMessages(): string[] {
  const messages = [...FIRE_LOADING_MESSAGES];

  for (let index = messages.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(Math.random() * (index + 1));
    [messages[index], messages[swapIndex]] = [messages[swapIndex]!, messages[index]!];
  }

  return messages;
}
